import * as React from 'react';
import ProductionComponent from './production';
import { Production } from '../classes/production';

export interface ExternalProps {
    productionList: Production[];
}

export class ProductionListComponent extends React.Component<ExternalProps, null> {
    constructor(props: ExternalProps) {
        super(props);
    }

    render() {
        return (
            <div className="swiper-wrapper sponsors-carousel-wrapper full-carousel-item-container">
                {
                    this.props.productionList.map(production => <ProductionComponent production={production} key={this.props.productionList.indexOf(production)} /> )
                }
            </div>
        );
    }
}